import React from "react";
import { withStyles } from "@material-ui/core";
import Tooltip from "../../../common/StyledToolTip";
import { ToggleRenderer } from '@dataGrid/components/cellRenderer'
import styles from "../../../../layout/layoutHeader/components/styles";

const ExpandDriverStopList = ({ classes, ...props }) => {
  return (
    <Tooltip title="Enable/Disable Show Expanded Stop List">
      <div className={`${classes.toggleAnimationButtonDispatchMap} glHeaderIcons ${props.isMenuItem ? classes.toggleAnimationButtonMenu : ""}`}>
        <div className={classes.toggleText}>Show Expanded Stop List </div>
        <ToggleRenderer
          value={props.isEnabled}
          onChange={props.toggleExpandDriverStopList}
        />
      </div>
    </Tooltip>
  );
};

export default withStyles(styles)(ExpandDriverStopList);
